import { render, staticRenderFns } from "./PurchaseOrderLockNotification.vue?vue&type=template&id=45944a98&scoped=true"
import script from "./PurchaseOrderLockNotification.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderLockNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45944a98",
  null
  
)

export default component.exports